import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import {
  CalendarToday as CalendarIcon,
  Mic as MicIcon,
} from '@mui/icons-material';

const TheVoiceProject: React.FC = () => {
  return (
    <Box>
      {/* Header avec titre et image */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <img
          src="/TV/The_Voice.png"
          alt="Logo The Voice"
          style={{
            width: '64px',
            height: '64px',
            objectFit: 'contain',
            filter: 'drop-shadow(2px 2px 4px rgba(167, 139, 250, 0.3))',
          }}
        />
        <Typography
          variant="h4"
          component="h2"
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          The Voice
        </Typography>
      </Box>

      {/* Statut et date */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalendarIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            2018-2020
          </Typography>
        </Box>
      </Box>

      {/* Description */}
      <Typography
        variant="body1"
        sx={{ mb: 3, lineHeight: 1.6 }}
      >
        Mission de maintenance et évolution de l'émission "The Voice". Gestion des mises à jour 
        de l'habillage graphique et des systèmes techniques, avec participation active au suivi 
        plateau pour assurer la continuité et la qualité de production de cette émission 
        emblématique de TF1.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Missions réalisées */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Missions réalisées
        </Typography>
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 2
        }}>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Maintenance systèmes techniques
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Mise à jour habillage graphique
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Évolutions visuelles
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Suivi plateau en direct
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Support technique émission
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Tests et validation
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Domaines techniques */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Domaines techniques
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {['Maintenance système', 'Habillage graphique', 'Support plateau', 'Évolutions visuelles', 'Optimisation'].map((tech) => (
            <Chip
              key={tech}
              label={tech}
              variant="filled"
              size="small"
              sx={{
                background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.1) 0%, rgba(20, 184, 166, 0.1) 100%)',
                color: '#a78bfa',
                border: '1px solid rgba(167, 139, 250, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.2) 0%, rgba(20, 184, 166, 0.2) 100%)',
                },
              }}
            />
          ))}
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Défis techniques */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Défis techniques relevés
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Maintenance en continu :</strong> Assurer la maintenance des systèmes 
          techniques pendant les saisons de diffusion avec un impact minimal sur la 
          production et une disponibilité maximale.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Support plateau critique :</strong> Intervenir en temps réel lors 
          des enregistrements pour résoudre immédiatement tout problème technique 
          et maintenir la fluidité de production.
        </Typography>
        <Typography variant="body2">
          <strong>Continuité de service :</strong> Garantir une expérience télévisuelle 
          sans faille pour une émission à forte audience avec des contraintes de planning 
          et de qualité extrêmement strictes.
        </Typography>
      </Box>
    </Box>
  );
};

export default TheVoiceProject;
